/** @format */
import React from 'react';
import PropTypes from 'prop-types';

const SubmissionActivityIcon = ({ 
  className = "h-7 w-7", 
  activityLevel = "normal", // "normal", "high", "spike"
  showPinkAccent = false 
}) => {
  return (
    <div className="relative">
      <svg 
        className={className} 
        viewBox="0 0 32 32" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Submission activity heatmap icon"
      >
        {/* Document/form base */}
        <rect 
          x="8" 
          y="4" 
          width="16" 
          height="22" 
          rx="2" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          fill="none"
        />
        
        {/* Document header line */}
        <path 
          d="M11 8h10" 
          stroke="currentColor" 
          strokeWidth="1" 
          strokeLinecap="round"
          opacity="0.6"
        />
        
        {/* Form fields represented as lines */}
        <g opacity="0.5">
          <path d="M11 12h6" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
          <path d="M11 15h8" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
          <path d="M11 18h4" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
          <path d="M11 21h7" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
        </g>
        
        {/* Activity pulse/heatmap visualization */}
        <g opacity="0.8">
          {/* Small activity squares representing heatmap */}
          <rect x="18" y="12" width="1.5" height="1.5" fill="currentColor" opacity="0.4" rx="0.2" />
          <rect x="20" y="12" width="1.5" height="1.5" fill="currentColor" opacity="0.6" rx="0.2" />
          <rect x="18" y="14" width="1.5" height="1.5" fill="currentColor" opacity="0.7" rx="0.2" />
          <rect x="20" y="14" width="1.5" height="1.5" fill="currentColor" opacity="0.9" rx="0.2" />
          <rect x="18" y="16" width="1.5" height="1.5" fill="currentColor" opacity="0.5" rx="0.2" />
          <rect x="20" y="16" width="1.5" height="1.5" fill="currentColor" opacity="0.8" rx="0.2" />
        </g>
      </svg>
      
      {/* Pink activity pulse indicator - conditional based on props */}
      {(showPinkAccent || activityLevel === "spike") && (
        <div className={`absolute -top-0.5 -right-0.5 w-3 h-3 bg-primary rounded-full border-2 border-white ${activityLevel === "spike" ? "animate-pulse" : ""}`}>
        </div>
      )}
    </div>
  );
};

SubmissionActivityIcon.propTypes = {
  className: PropTypes.string,
  activityLevel: PropTypes.oneOf(['normal', 'high', 'spike']),
  showPinkAccent: PropTypes.bool,
};

export default SubmissionActivityIcon;